export class AddUser {
    ABNumber!: number;
    Name!: string;
     CAI!: string;
     Role!: string;
     Email!: string;
     CreatedDate ? : Date;
     CreatedBy!: string;
     UpdatedDate ? : Date;
     UpdatedBy ?: string;
     IsActive ? :  Boolean;
     ProvisioningID! : string;
}
